// extracted by mini-css-extract-plugin
export default {"container":"CpTlqqyr73T9tBXsMvbW","modal":"RpcoAOIH8tpIRdvkMcaR","head":"STR_uXyM0pWrGFFhtcm_","body":"rNNqwb9a6AtFX6QenDBH"};